import script from "./ViewEventView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewEventView.vue?vue&type=script&setup=true&lang=ts"

import "./ViewEventView.vue?vue&type=style&index=0&id=317efd12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317efd12"]])

export default __exports__